module.exports = __webpack_public_path__ + "static/gallery1-f347497fddd2e6b92e5cecc17899f4b9.jpg";